import React from 'react';

import { Typography } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Translate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Link } from 'react-router';

import flipDishLogo from '../../../weborder/assets/images/flipDishLogo.svg';
import { cookieConsent } from '../../../weborder/cookieconsent';
import { cookieSelectors } from '../../../weborder/selectors';
import { getAppConfig } from '../../../weborder/selectors/basketSelectors';
import { Flex } from '../../layouts';

type StateProps = {
  cookiePolicyLink: string;
  hasGdprCookieFeatureFlag: boolean;
  privacyLink: string;
  termsLink: string;
};

const useStyles = makeStyles((theme: Theme) => ({
  privacyTerms: {
    margin: '0 auto',
  },
  logo: {
    height: '25px',
    paddingBottom: theme.spacing(0.5),
    width: '92px',
  },
  link: {
    color: 'inherit',
    cursor: 'pointer',
  },
}));

type Props = StateProps;

function PrivacyTerms(props: Props): JSX.Element {
  const classes = useStyles(props);
  const showCookieSettings = props.hasGdprCookieFeatureFlag;

  const handleShowSettings = () => {
    cookieConsent.edit();
  };

  return (
    <Flex direction="column" align="center" className={classes.privacyTerms}>
      <img src={flipDishLogo} alt="Flipdish logo" className={classes.logo} />

      <Typography variant="caption">
        <Translate id="secured_with_Flipdish" />
      </Typography>

      {showCookieSettings && (
        <Link
          className={classes.link}
          onClick={handleShowSettings}
          tabIndex={0}
          to=""
        >
          <Typography variant="caption">
            <Translate id="cookie_settings" />
          </Typography>
        </Link>
      )}
    </Flex>
  );
}

const mapStateToProps = (state): StateProps => {
  const config = getAppConfig(state);
  const getConfig = (param) => (config[param] ? config[param] : '');

  return {
    cookiePolicyLink: getConfig('CookiePolicyUrl'),
    hasGdprCookieFeatureFlag: cookieSelectors.hasGdprCookieFeatureFlag(state),
    privacyLink: getConfig('PrivacyPolicyUrl'),
    termsLink: getConfig('TermsAndConditionsUrl'),
  };
};

export default connect(mapStateToProps)(PrivacyTerms);
